/* Craftmark custom safety tag builder (snippets/cm-tag-builder.liquid, buy_config.tagBuilder)
   Live preview of a custom tag: OSHA header (or the customer's logo), background colour, legend lines,
   "Signed by / Date" write-on lines, front and back. */
(function () {
  'use strict';
  var el0 = document.getElementById('cm-tag-cfg'); if (!el0) return;
  var CFG = {}; try { CFG = JSON.parse(el0.textContent) || {}; } catch (e) {}
  var T = CFG.tagBuilder || {};
  var NS = 'http://www.w3.org/2000/svg';
  var FONT = '"Helvetica Bold Craftmark", "Helvetica Neue", Helvetica, Arial, sans-serif';
  var INK = '#231f20';
  var HDR = {
    DANGER: { bar: '#ed1c24', text: '#ffffff', tri: '#ffffff', bang: '#ed1c24' },
    CAUTION: { bar: '#fdd800', text: INK, tri: INK, bang: '#fdd800' },
    WARNING: { bar: '#f58220', text: INK, tri: INK, bang: '#f58220' },
    NOTICE: { bar: '#1468c2', text: '#ffffff', italic: true },
    THINK: { bar: '#0b9348', text: '#ffffff', italic: true }
  };
  // standard background / text colour pairs (catalog colour chart)
  var BG = {
    'Red': ['#ed1c24', '#ffffff'], 'Blue': ['#6cb4e4', INK], 'Yellow': ['#fff200', INK], 'Orange': ['#f7941d', INK],
    'Green': ['#00a650', INK], 'Black': ['#231f20', '#ffffff'], 'White': ['#ffffff', INK], 'Brown': ['#6b4226', '#ffffff'], 'Purple': ['#8e1b8e', '#ffffff']
  };
  function el(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) if (a[k] != null) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
  function clear(s) { while (s.firstChild) s.removeChild(s.firstChild); }
  var mctx = document.createElement('canvas').getContext('2d');
  function measure(t, fs) { mctx.font = '700 ' + fs + 'px "Helvetica Bold Craftmark", Helvetica, Arial, sans-serif'; return mctx.measureText(t).width; }
  function form() { return document.getElementById('custom_product_form'); }
  function xsel(name) { var f = form(); return f ? f.querySelector('[data-xsel="' + name + '"]') : null; }
  function opt(name) { return document.querySelector('.product_option_select[data-option-label="' + name + '"]'); }
  function val(e) { return e && !e.disabled ? e.value : ''; }
  function lines(prefix) {
    var out = [], n = T.lines || 4;
    for (var i = 1; i <= n; i++) {
      var e = prefix ? document.getElementById('cm_tag_back_' + i) : document.querySelector('[data-text-line="' + i + '"]');
      out.push(e && !e.disabled ? String(e.value || '').toUpperCase().trim() : '');
    }
    while (out.length && !out[out.length - 1]) out.pop();
    return out;
  }
  function sizeRatio() {
    var s = opt(T.sizeOption || 'Size'), v = s ? s.value : '', m = /([\d.]+)\s*["”]?\s*[xX×]\s*([\d.]+)/.exec(v);
    return m ? parseFloat(m[1]) / parseFloat(m[2]) : (T.ratio || 0.58);
  }
  function twoSided() { var s = opt(T.sidesOption || 'Sides'); return !!(s && /two/i.test(s.value)); }

  // header bar (OSHA formats) or the customer's logo
  function header(g, x, y, w, h, hdr, logoUrl) {
    if (hdr === 'LOGO') {
      el('rect', { x: x, y: y, width: w, height: h, fill: '#ffffff', stroke: '#c8ccd0', 'stroke-width': 2, 'stroke-dasharray': logoUrl ? 'none' : '8 6' }, g);
      if (logoUrl) el('image', { href: logoUrl, x: x + 6, y: y + 6, width: w - 12, height: h - 12, preserveAspectRatio: 'xMidYMid meet' }, g);
      else { var t = el('text', { x: x + w / 2, y: y + h / 2 + 10, 'text-anchor': 'middle', 'font-family': FONT, 'font-weight': 700, 'font-size': 30, fill: '#9aa3ad' }, g); t.textContent = 'YOUR LOGO'; }
      return;
    }
    var st = HDR[hdr] || HDR.DANGER;
    el('rect', { x: x, y: y, width: w, height: h, fill: st.bar, stroke: st.italic ? 'none' : INK, 'stroke-width': st.italic ? 0 : 5 }, g);
    var cap, fs, tw;
    if (st.italic) {
      cap = h * 0.62; fs = cap / 0.717; tw = measure(hdr, fs); var mw = w - 40; if (tw > mw) { fs *= mw / tw; cap = fs * 0.717; }
      var gg = el('g', { transform: 'translate(' + (x + w / 2) + ',' + (y + h / 2 + cap / 2) + ') skewX(-12)' }, g);
      var t1 = el('text', { x: 0, y: 0, 'text-anchor': 'middle', 'font-family': FONT, 'font-weight': 700, 'font-size': fs.toFixed(1), fill: st.text }, gg); t1.textContent = hdr;
      return;
    }
    cap = h * 0.56; fs = cap / 0.717; tw = measure(hdr, fs);
    var triW = cap * 1.16, gap = cap * 0.1, total = triW + gap + tw, maxT = w - 30;
    if (total > maxT) { var k = maxT / total; fs *= k; cap *= k; tw *= k; triW *= k; gap *= k; total = maxT; }
    var gx = x + w / 2 - total / 2, base = y + h / 2 + cap / 2, tt = base - cap;
    el('path', { d: 'M' + (gx + triW / 2) + ',' + tt + ' L' + (gx + triW) + ',' + base + ' L' + gx + ',' + base + ' Z', fill: st.tri, stroke: st.tri, 'stroke-width': (cap * 0.11).toFixed(1), 'stroke-linejoin': 'round' }, g);
    var ex = gx + triW / 2;
    el('path', { d: 'M' + (ex - cap * 0.075) + ',' + (tt + cap * 0.3) + ' L' + (ex + cap * 0.075) + ',' + (tt + cap * 0.3) + ' L' + (ex + cap * 0.045) + ',' + (base - cap * 0.34) + ' L' + (ex - cap * 0.045) + ',' + (base - cap * 0.34) + ' Z', fill: st.bang }, g);
    el('circle', { cx: ex, cy: base - cap * 0.17, r: (cap * 0.075).toFixed(1), fill: st.bang }, g);
    var t2 = el('text', { x: (gx + triW + gap).toFixed(1), y: base.toFixed(1), 'font-family': FONT, 'font-weight': 700, 'font-size': fs.toFixed(1), fill: st.text }, g); t2.textContent = hdr;
  }

  // one tag face, drawn at x0 (width W, height H)
  function face(g, x0, W, H, o) {
    var cut = W * 0.22, top = 0;
    var path = 'M' + (x0 + cut) + ',' + top + ' L' + (x0 + W - cut) + ',' + top + ' L' + (x0 + W) + ',' + (top + cut) + ' L' + (x0 + W) + ',' + H + ' L' + x0 + ',' + H + ' L' + x0 + ',' + (top + cut) + ' Z';
    el('path', { d: path, fill: o.bg, stroke: INK, 'stroke-width': 6, 'stroke-linejoin': 'round' }, g);
    // brass grommet
    var gy = cut * 0.62, gr = W * 0.055;
    el('circle', { cx: x0 + W / 2, cy: gy, r: gr, fill: '#c9954a', stroke: '#8a6430', 'stroke-width': 2 }, g);
    el('circle', { cx: x0 + W / 2, cy: gy, r: gr * 0.48, fill: '#ffffff', stroke: '#8a6430', 'stroke-width': 1.5 }, g);
    var pad = W * 0.06, hy = cut + W * 0.03, hh = W * 0.2;
    header(g, x0 + pad, hy, W - 2 * pad, hh, o.hdr, o.logo);
    // write-on lines at the bottom
    var footTop = H;
    if (o.signed) {
      var fs2 = W * 0.05, ly1 = H - W * 0.16, ly2 = H - W * 0.07;
      [['Signed by', ly1], ['Date', ly2]].forEach(function (r) {
        var t = el('text', { x: x0 + pad, y: r[1], 'font-family': FONT, 'font-weight': 700, 'font-size': fs2, fill: o.fg }, g); t.textContent = r[0];
        var lx = x0 + pad + measure(r[0], fs2) + fs2 * 0.4;
        el('line', { x1: lx, y1: r[1], x2: x0 + W - pad, y2: r[1], stroke: o.fg, 'stroke-width': 2 }, g);
      });
      footTop = ly1 - fs2 * 1.6;
    }
    // legend
    var L = o.lines.length ? o.lines : [o.placeholder || 'YOUR TEXT'];
    var areaTop = hy + hh + W * 0.06, areaBot = footTop - W * 0.03, areaH = areaBot - areaTop, areaW = W - 2 * pad - 6;
    var n = L.length, fs = Math.min(W * 0.2, areaH / (n * 1.12) / 0.92);
    var lh = fs * 1.12, y = areaTop + (areaH - n * lh) / 2 + fs * 0.86;
    L.forEach(function (s) {
      var w = measure(s, fs), sq = w > areaW ? areaW / w : 1, f2 = fs;
      if (sq < 0.62) { f2 = fs * sq / 0.62; sq = 0.62; } // condense first (like the catalog tags), then shrink
      var t = el('text', { x: 0, y: 0, 'text-anchor': 'middle', 'font-family': FONT, 'font-weight': 700, 'font-size': f2.toFixed(1), fill: o.fg, transform: 'translate(' + (x0 + W / 2) + ',' + y.toFixed(1) + ') scale(' + sq.toFixed(3) + ',1)' }, g);
      if (!o.lines.length) t.setAttribute('opacity', '0.4');
      t.textContent = s; y += lh;
    });
  }

  var logoUrl = '';
  function render() {
    var svg = document.getElementById('cm_tag_svg'); if (!svg) return;
    clear(svg);
    var ratio = sizeRatio(), W = 420, H = Math.round(W / ratio), gap = 70;
    var hdr = val(xsel(T.headerSelect || 'Header')) || T.defaultHeader || 'DANGER';
    if (/logo/i.test(hdr)) hdr = 'LOGO';
    var cname = val(xsel(T.colorSelect || 'Background Color')), c = BG[String(cname).split(' ')[0]] || ['#ffffff', INK];
    var two = T.sidesOption ? twoSided() : false;
    var faces = [{ title: 'Front', lines: lines(false) }];
    if (two) faces.push({ title: 'Back', lines: lines(true) });
    var total = faces.length * W + (faces.length - 1) * gap, pad = 30;
    svg.setAttribute('viewBox', (-pad) + ' ' + (-pad) + ' ' + (total + 2 * pad) + ' ' + (H + 2 * pad + 40));
    faces.forEach(function (f, i) {
      var x0 = i * (W + gap), g = el('g', {}, svg);
      face(g, x0, W, H, { hdr: hdr, logo: logoUrl, bg: c[0], fg: c[1], lines: f.lines, signed: T.signedBy !== false, placeholder: T.placeholder });
      if (faces.length > 1) { var t = el('text', { x: x0 + W / 2, y: H + 34, 'text-anchor': 'middle', 'font-family': 'Helvetica, Arial, sans-serif', 'font-size': 22, fill: '#666' }, svg); t.textContent = f.title; }
    });
    var cap = document.getElementById('cm_tag_size'); if (cap) { var s = opt(T.sizeOption || 'Size'); cap.textContent = s ? s.value : (T.sizeText || ''); }
  }

  function setup() {
    var f = form(); if (!f) return;
    // legend inputs: capitals, a sensible length, nicer labels
    [].forEach.call(f.querySelectorAll('[data-text-line]'), function (inp, i) {
      inp.setAttribute('maxlength', '28'); inp.style.textTransform = 'uppercase'; inp.setAttribute('placeholder', 'LINE ' + (i + 1));
      inp.addEventListener('input', function () { var s = inp.selectionStart, u = inp.value.toUpperCase(); if (u !== inp.value) { inp.value = u; try { inp.setSelectionRange(s, s); } catch (e) {} } });
      var lab = inp.closest('.product_variation_field') && inp.closest('.product_variation_field').querySelector('label'); if (lab) lab.textContent = (T.sidesOption ? 'Front ' : '') + 'Line ' + (i + 1);
    });
    // back-side lines for two-sided tags
    if (T.sidesOption) {
      var last = f.querySelectorAll('[data-text-line]'); last = last[last.length - 1];
      var anchor = last ? last.closest('.product_variation_field') : null;
      if (anchor) for (var i = (T.lines || 4); i >= 1; i--) {
        var row = document.createElement('div'); row.className = 'product_variation_field row mb-4 align-items-center cm-tag-back';
        row.innerHTML = '<div class="col-2 label_col"><label for="cm_tag_back_' + i + '">Back Line ' + i + '</label></div><div class="field_col col-10"><input type="text" id="cm_tag_back_' + i + '" name="properties[Back Line ' + i + ']" maxlength="28" placeholder="LINE ' + i + '" style="text-transform:uppercase"></div>';
        anchor.parentNode.insertBefore(row, anchor.nextSibling);
      }
      var sync = function () { var two = twoSided(); [].forEach.call(f.querySelectorAll('.cm-tag-back'), function (r) { r.style.display = two ? '' : 'none'; var inp = r.querySelector('input'); inp.disabled = !two; }); };
      document.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('product_option_select')) setTimeout(function () { sync(); render(); }, 0); });
      sync();
    }
    // logo upload when the header choice is "your logo"
    var hs = xsel(T.headerSelect || 'Header');
    if (hs && T.logo) {
      var lr = document.createElement('div'); lr.className = 'product_variation_field row mb-4 align-items-center cm-tag-logo';
      lr.innerHTML = '<div class="col-2 label_col"><label for="cm_tag_logo">Your logo</label></div><div class="field_col col-10"><input type="file" id="cm_tag_logo" accept="image/*,.pdf,.ai,.eps,.svg"><input type="hidden" name="properties[Logo File]" id="cm_tag_logo_url" disabled><div class="cm-xsel-help" id="cm_tag_logo_msg">PNG, JPG, SVG or PDF. We’ll send a proof before printing.</div></div>';
      var hrow = hs.closest('.product_variation_field'); hrow.parentNode.insertBefore(lr, hrow.nextSibling);
      var fi = lr.querySelector('#cm_tag_logo'), hid = lr.querySelector('#cm_tag_logo_url'), msg = lr.querySelector('#cm_tag_logo_msg');
      var showLogo = function () { var on = /logo/i.test(hs.value); lr.style.display = on ? '' : 'none'; hid.disabled = !on || !hid.value; };
      hs.addEventListener('change', function () { showLogo(); render(); }); showLogo();
      fi.addEventListener('change', function () {
        var file = fi.files && fi.files[0]; if (!file) return;
        if (/^image\/(png|jpe?g|gif|svg\+xml|webp)$/.test(file.type)) { logoUrl = URL.createObjectURL(file); render(); }
        var uc = window.uploadcare, pk = window.UploadKit && window.UploadKit.config && window.UploadKit.config.ucKey;
        if (!uc || !uc.fileFrom || !pk) { msg.textContent = 'Upload not available — email your logo to csr@craftmarkid.com after ordering.'; return; }
        msg.textContent = 'Uploading…';
        uc.fileFrom('object', file, { publicKey: pk }).done(function (info) { hid.value = info.cdnUrl; hid.disabled = false; msg.textContent = 'Logo uploaded: ' + file.name; })
          .fail(function () { msg.textContent = 'Upload failed — email your logo to csr@craftmarkid.com after ordering.'; });
      });
    }
  }

  function init() {
    setup();
    document.addEventListener('input', function () { render(); }, true);
    document.addEventListener('change', function () { setTimeout(render, 0); }, true);
    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
    setTimeout(render, 600);
    window.cmTagRender = render;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
